import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import Input from "sushiweb/InputTypes/Input";
import { green } from "sushiweb/tokens/color";

import DropdownComponent from '../core/DropdownComponent';
import * as symbols from '../../operations/symbols';
import './orders.scss';
import * as constants from '../../operations/constants';
import * as actions from "../../actions/ordersAction";
import PictureModeModal from '../core/PictureModeModal';
import { PhotoMainViewer } from '../core/PhotoViewerComponent';
import { round } from '../../operations/operations';

class ProductCardComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFilter: { key: 0, value: 'None', sendValue: 0 },
      quantityValue: '',
      collapsed: [],
      issue: null,
      reasonWarning: false,
      disableCardTrack: [],
      currentCardId: null,
      photos: [],
      openPictureModeModal: false,
      uploadedImages: [],
      issueId: null,
      imageWarning: false,
      finalUpdatedValue: null,
      issueInQuantity: "",
      issueInQtyReason: ""
    }
  }

  handleIssueChange() {
    const val = this.state.quantityValue;
    if (val < this.props.product.quantityDispatched) {
      this.setState(prevState => ({
        issue: {
          ...this.props.product.issue,
          reasonId: this.state.selectedFilter.sendValue,
          quantityDelivered: parseFloat(val),
          issueInQuantity: this.state.issueInQuantity,
          subUom: this.props.product.subUom
        },
      }))
    } else if (val === this.props.product.quantityDispatched) {
      this.setState({ issue: {} })
    }
  }

  handleIssueInQuantityChange = (value) => {
    if (isNaN(value)) {
      return
    }
    const { product } = this.props;
    const maxIssueInQty = Number(product.quantityDispatched) * Number(product.subUomCount);
    if (maxIssueInQty && Number(value) > Number(maxIssueInQty)) {
      return;
    }
    
    const quantityDelivered = Number(product.quantityDispatched) - round((Number(value) / Number(product.subUomCount)),2);
    this.setState({ issueInQuantity: value, quantityValue: round(quantityDelivered, 2), issueInQtyReason: "" }, () => this.handleIssueChange())
  }

  getValue(val) {
    this.setState({ quantityValue: val }, () => this.handleIssueChange())
  }

  componentDidMount() {
    let val = this.props.product.quantityDispatched;
    let selectedFilter = { key: 0, value: 'None', sendValue: 0 };
    if (this.props.product.issue !== null) {
      val = this.props.product.issue.quantityDelivered;
      const issueReason = this.props.reasons.find((ele) => ele.key === this.props.product.issue.reasonId);
      if (issueReason) {
        selectedFilter = issueReason
      }
    }

    let uploadedImages = this.props.product.issue ? [...this.props.product.issue.images] : []
    uploadedImages.reverse();
    this.setState({
      quantityValue: val,
      selectedFilter,
      issueId: this.props.product.issue ? this.props.product.issue.issueId : null,
      finalUpdatedValue: val,
      issue: this.props.product.issue,
      issueInQuantity: this.props.product.issue ? this.props.product.issue.issueInQuantity : "",
      uploadedImages
    })
  }

  setQuantityValue(e) {
    if (e.target.value <= this.props.product.quantityDispatched) {
      this.setState({ quantityValue: (e.target.value) }, () => this.handleIssueChange());
    }
  }

  setBlurQunatityValue(e) {
    if (e.target.value === '') {
      this.setState({ quantityValue: (this.props.product.quantityDispatched) }, () => this.handleIssueChange());
    }
  }

  handleReasonSelect(reason) {
    this.setState({ selectedFilter: reason, reasonWarning: false }, () => this.handleIssueChange())
  }

  clearAddPhotos() {
    this.setState({ photos: [] })
  }


  componentDidUpdate(prevProps) {
    const { saveProductIssuesStatus, orders, product, deleteProductIssuesStatus } = this.props;
    if (this.props.isOpen && orders && saveProductIssuesStatus !== prevProps.saveProductIssuesStatus && saveProductIssuesStatus === symbols.STATUS_DONE) {
      this.closeCard();
      const deliveredCount = Number(this.props.product.quantityDispatched) - (Number(this.state.issueInQuantity) / Number(this.props.product.subUomCount));
      this.props.getDeliveredQty(deliveredCount, this.props.product.id);

      const uploadedImages = [...this.state.uploadedImages];
      for (let i in this.state.photos) {
        uploadedImages.unshift({ url: URL.createObjectURL(this.state.photos[i]) })
      }
      this.setState({ uploadedImages, imageWarning: false, reasonWarning: false, finalUpdatedValue: this.state.quantityValue }, () => {
        this.clearAddPhotos()
      })
    }
    if (product.issue != prevProps.product.issue) {
      this.setState({ issue: product.issue })
    }
    if (deleteProductIssuesStatus !== prevProps.deleteProductIssuesStatus && deleteProductIssuesStatus === symbols.STATUS_DONE) {
      this.closeCard();
      const deliveredCount = Number(this.props.product.quantityDispatched) - (Number(this.state.issueInQuantity) / Number(this.props.product.subUomCount));
      this.props.getDeliveredQty(deliveredCount, this.props.product.id);
      if (this.props.product.id == this.props.orders.deletedProductId)
        this.setState({
          uploadedImages: [],
          issue: null,
          imageWarning: false,
          reasonWarning: false,
          issueId: null,
          finalUpdatedValue: null,
          selectedFilter: { key: 0, value: 'None', sendValue: 0 },
          issueInQuantity: 0,
          issueInQtyReason: ""
        }, () => {
          this.clearAddPhotos()
        })
    }
  }

  toggleCard(openOnly) {
    if (openOnly && !this.props.isOpen) {
      this.props.setIsOpen(this.props.product.id);
      return
    }
    if ((this.state.issue === null || Object.keys(this.state.issue).length == 0) && this.state.quantityValue == this.props.product.quantityDispatched && (!this.state.selectedFilter.sendValue && !this.state.issueInQuantity)) {
      this.props.setIsOpen(this.props.product.id);
      return
    }

  }


  closeCard() {
    this.props.setClose();
  }

  toggleDefaultStateCard() {
    if (this.props.isOpen) {
      this.props.setClose();
      return
    }
    this.props.setIsOpen(this.props.product.id);
  }

  getIssueId(id) {
    this.setState(prevState => ({
      issueId: id
    }))
  }

  removeImage(e, currIndex) {
    let photos = [...this.state.photos];
    photos = photos.filter((ele, index) => {
      if (currIndex !== index) {
        return true
      }
    })
    this.setState({ photos })
  }

  openPictureModeModal() {
    this.setState({ openPictureModeModal: true, imageWarning: false })
  }

  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  handleIssueSubmit(e) {
    e.stopPropagation();
    this.toggleCard(true);
    const productId = this.props.product.id;

    this.setState({ currentCardId: this.props.product.id })
    if (!this.props.isOpen) {
      return
    }
    if (this.state.selectedFilter.key === 0 && this.state.quantityValue < this.props.product.quantityDispatched) {
      this.setState({ reasonWarning: true });
      return;
    }
    if (this.state.selectedFilter.sendValue && !this.state.issueInQuantity) {
      this.setState({ issueInQtyReason: "Issue in Quantity is required" });
      return;
    }


    if (this.state.uploadedImages.length == 0 && this.state.photos.length == 0 && this.state.quantityValue < this.props.product.quantityDispatched) {
      let flag = 0;
      this.props.reasons.map((ele) => {
        if (ele.sendValue === this.state.selectedFilter.sendValue && ele.rules && ele.rules.indexOf(constants.REASON_RULE_PHOTO_MANDATE) != -1) {
          this.setState({ imageWarning: true });
          flag = 1;
        }
      })

      if (flag == 1) {
        return;
      } else {
        this.setState({ imageWarning: false });
      }

    }

    let issueId = null;

    //only useful for first reload
    if (this.props.product.issue) {
      issueId = this.props.product.issue.issueId;
    }

    //this will update issueId after subsequent calls - will keep issueId as null after delete which will override the issueId set above from first reload state
    if (this.props.orders.updatedProductIssue[productId] || this.props.orders.deletedProductId == productId) {
      issueId = this.props.orders.updatedProductIssue[productId];
    }

    if (!issueId && this.state.quantityValue == this.props.product.quantityDispatched) {
      this.closeCard();
      return;
    }

    const formData = new FormData();

    if (this.state.issue) {
      const quantityDelivered = Number(this.props.product.quantityDispatched) - round((Number(this.state.issueInQuantity) / Number(this.props.product.subUomCount)),2);

      formData.append('reasonId', this.state.issue.reasonId);
      formData.append('quantityDelivered', round(quantityDelivered, 2));
      formData.append('issueInQuantity', this.state.issueInQuantity);
      formData.append('subUom', this.props.product.subUom);

      for (let i = 0; i < this.state.photos.length; i++) {
        formData.append('files', this.state.photos[i]);
      }
    }

    // payload.files = formData;
    if (this.state.quantityValue < this.props.product.quantityDispatched) {
      this.props.setIssue(this.props.product.id, this.state.issue)
    } else {
      this.props.deleteIssue(this.props.product.id)
    }


    if (this.state.quantityValue == this.props.product.quantityDispatched && issueId) {
      this.props.actions.deleteProductIssues(this.props.product.id, this.props.match.params.id, issueId)
    } else {
      this.props.actions.saveProductIssues(formData, this.props.product.id, this.props.match.params.id, issueId)
    }

  }

  setImages(files) {
    this.closePictureModeModal();
    const photos = [...this.state.photos];
    for (let i = 0; i < files.length; i++) {
      photos.push(files[i])
    }
    this.setState({ photos })
  }

  getDeliveredQty = () => {
    let { issueInQuantity } = this.state;
    let { product: { subUomCount = 0, quantityDispatched } } = this.props;

    let deliveredCount = round(Number(quantityDispatched) * Number(subUomCount), 2) - Number(issueInQuantity);
    return round(deliveredCount, 2);
  }

  render() {
    const { product, staticCard } = this.props;
    const {
      quantityValue,
      openPictureModeModal,
      issueInQtyReason
    } = this.state;

    let shadowClass = '';
    if (this.props.isOpen) {
      shadowClass = 'shadow'
    }

    return (
      <div className={
        this.props.allReset || this.props.isOpen ? `product-card mt-1 ${shadowClass}` : `product-card mt-1 product-card-disable ${shadowClass}`
      }
      >
        <PictureModeModal
          isOpen={openPictureModeModal}
          hasNotWrapper={true}
          closePictureModeModal={() => this.closePictureModeModal()}
          hasSameRoute={true}
          default={true}
          setImages={(files) => this.setImages(files)}
        />
        <div className="product-title">
          <div className="name mr-1"> {product.skuName}
            {
              !this.props.isOpen && this.state.uploadedImages && this.state.uploadedImages.length > 0 &&
              <div className="sub-title-msg">
                <FontAwesomeIcon icon="camera" />&nbsp;
              {this.state.uploadedImages.length} photo
              {this.state.uploadedImages.length > 1 ? 's' : ''} uploaded
            </div>
            }
          </div>
          {
            !this.props.isOpen ?
              <React.Fragment>
                <span className="qty mr-1">
                  {
                    (this.state.finalUpdatedValue || this.state.finalUpdatedValue === 0) && (product.quantityDispatched != this.state.finalUpdatedValue) ?
                      <span className="line-through gray-text">
                        {product.quantityDispatched}
                      </span> : null
                  }

                  &nbsp; <b>{quantityValue} {product.measurementUnit}</b>
                </span>
                <div className="flex flex-vertical-align" onClick={(e) => this.handleIssueSubmit(e)}>
                  <span className="green-text mr-1">Edit</span>
                  <FontAwesomeIcon icon="angle-down" className="gray-text qty" />
                </div>
              </React.Fragment>
              :
              this.props.saveProductIssuesStatus === symbols.STATUS_BEGIN && this.props.isOpen ?
                <div className="btn btn-green-small btn-transparent-green">
                  Saving
                </div>
                :
                <div className="btn btn-white btn-card-small" onClick={(e) => this.handleIssueSubmit(e)}>
                  Done
                </div>
          }
        </div>
        <div className={this.props.isOpen ? "orders-body" : "collapsed-body"}>
          {

            <div>
              <div className="light-line" />
              <div className="row flex">
                <div className="col-xs-6 subtitle ">
                  Quantity Ordered
                </div>
                <div className="col-xs-6 align-right w-600">
                  {product.quantityOrdered} units ({product.subUomCount * product.quantityOrdered} {constants.SUB_UOM[product.subUom] ? constants.SUB_UOM[product.subUom] : product.subUom })
                </div>
              </div>
              <div className="row mt-1 flex ">
                <div className="col-xs-6 subtitle ">
                  Quantity Dispatched
                </div>
                <div className="col-xs-6 align-right w-600">
                  {product.quantityDispatched} units ({product.subUomCount * product.quantityDispatched} {constants.SUB_UOM[product.subUom] ? constants.SUB_UOM[product.subUom] : product.subUom })
                </div>
              </div>
              <div className="row mt-1 flex">
                <div className="col-xs-6 subtitle ">
                  Quantity Delivered
                  </div>
                <div className="col-xs-6  w-600 align-right ">
                  {this.state.quantityValue} units {`(${this.getDeliveredQty()} ${constants.SUB_UOM[product.subUom] ? constants.SUB_UOM[product.subUom] : product.subUom })`}
                  <div className="clearfix" />
                </div>
              </div>

              {
                !staticCard &&
                <div className="mt-1 mb-1 row">
                  <div className={`${this.state.reasonWarning && this.state.quantityValue < this.props.product.quantityDispatched ? "red-text col-xs-12 mb-1" : "col-xs-12 mb-1"}`}><b>Select issue</b>
                  </div>
                  <div className="col-xs-12 mb-1">
                    <DropdownComponent
                      history={this.props.history}
                      primary={true}
                      className={this.state.reasonWarning ? 'red flex-margin z-highest small-content' : 'flex-margin z-highest small-content'}
                      menu={this.props.reasons}
                      defaultParam={this.state.selectedFilter}
                      handleClick={(param) => this.handleReasonSelect(param)}
                    />
                  </div>
                </div>
              }

              {
                !staticCard &&
                <div className="mt-1">
                  <div className={`${this.state.issueInQtyReason && this.state.selectedFilter.sendValue && !this.state.issueInQuantity ? "red-text col-xs-12 mb-1 pd-0" : "col-xs-12 mb-1 pd-0"}`}><b>Issue In Quantity</b>
                  </div>
                  <div className="issueQty">
                  <div className="col-xs-10">
                    <Input 
                      value={this.state.issueInQuantity || this.state.issueInQuantity === 0 ? this.state.issueInQuantity : undefined}
                      color={green.z500}
                      onChange={(value) => this.handleIssueInQuantityChange(value)}
                    />
                   
                  </div>
                  <div className="col-xs-2 mr-1">{constants.SUB_UOM[this.props.product.subUom] ? constants.SUB_UOM[this.props.product.subUom] : this.props.product.subUom }</div>
                  </div>
                  { issueInQtyReason && <div className="red-text ml-1 fs-12">{issueInQtyReason}</div>}
                </div>
              }
              <div className="order-photos mt-2">
                <div className={this.state.imageWarning ? "red-text subtitle" : "subtitle"}>
                  <b>Add Photos</b>
                </div>
                <div className="horizontal-scroll">

                  <div className="order-photo-wrapper">
                    <div
                      className={this.state.imageWarning ? "gallery-item order-photo-ele order-photo-placeholder red-order-photo-placeholder" : "gallery-item order-photo-ele order-photo-placeholder"}
                      onClick={() => this.openPictureModeModal()}
                    >
                      <FontAwesomeIcon icon="camera" />
                    </div>
                  </div>
                  {
                    this.state.photos && this.state.photos.map((ele, index) => {
                      return (
                        <div className="order-photo-wrapper">
                          <div className="cross-image" onClick={(e) => this.removeImage(e, index)}>
                            <FontAwesomeIcon icon="times" />
                          </div>
                          <div className={`gallery-item order-photo-ele`} style={{ 'backgroundImage': 'url(' + URL.createObjectURL(ele) + ')' }}></div>
                        </div>
                      )
                    })
                  }
                  {
                    this.state.uploadedImages
                    && this.state.uploadedImages.length > 0 &&
                    <div className="inline-block ">
                      <PhotoMainViewer
                        parentClass="order-photo-wrapper"
                        className="order-photo-ele "
                        photos={this.state.uploadedImages}
                        name="url"
                        mainClassName=""
                        openPictureModeModal={() => this.openPictureModeModal()}
                      />
                    </div>
                  }

                </div>

              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    saveProductIssuesStatus: state.statuses.saveProductIssues.status,
    saveProductIssuesError: state.statuses.saveProductIssues.error,
    deleteProductIssuesStatus: state.statuses.deleteProductIssues.status,
    deleteProductIssuesError: state.statuses.deleteProductIssues.error,
    orders: state.orders,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(ProductCardComponent));
